import { render, staticRenderFns } from "./SearchVendors.vue?vue&type=template&id=6393a162&"
import script from "./SearchVendors.vue?vue&type=script&lang=js&"
export * from "./SearchVendors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports